import { ajax } from '../index'

/**
 * Csotd相关接口
 */
export default {
  // 获取CSOTD商品数据
  getCrazyDeal() {
    return ajax.get('api', `/api/v1/product/crazy-deal/view`, {})
  },

  // 获取CSOTD页面 - Daily商品推荐
  getDailySideDeals(productID: number | string) {
    return ajax.get('api', `/api/v1/product/daily-side-deals/${productID}`, {})
  }
}